import { useQuery } from '@tanstack/react-query';
import getApi from '@/lib/axios';
import { ExtractFnReturnType } from '@/lib/react-query';
import { ConsolidationSummaryType } from '@/features/dashboard/types';

async function getTermometroGeral(params): Promise<ConsolidationSummaryType> {
  const api = await getApi();
  const { data } = await api.get<ConsolidationSummaryType>('/termometro/geral/', {
    params: {
      name: params.name || undefined,
    },
  });
  return data;
}

type QueryFnType = typeof getTermometroGeral;

function useTermometroGeral(params) {
  return useQuery<ExtractFnReturnType<QueryFnType>>({
    queryKey: ['termometro-geral', params.name],
    queryFn: () => getTermometroGeral(params),
  });
}

export { getTermometroGeral, useTermometroGeral };
